var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.193334 7.80667C0.25531 7.86915 0.329043 7.91875 0.410283 7.95259C0.491522 7.98644 0.578659 8.00387 0.666667 8.00387C0.754675 8.00387 0.841812 7.98644 0.923052 7.95259C1.00429 7.91875 1.07802 7.86915 1.14 7.80667L6.66667 2.27333L6.66667 6C6.66667 6.17681 6.7369 6.34638 6.86193 6.4714C6.98695 6.59643 7.15652 6.66667 7.33333 6.66667C7.51014 6.66667 7.67971 6.59643 7.80474 6.4714C7.92976 6.34638 8 6.17681 8 6L8 0.666667C8 0.489856 7.92976 0.320286 7.80474 0.195262C7.67971 0.0702378 7.51014 3.97595e-07 7.33333 3.97595e-07L2 3.97595e-07C1.82319 3.97595e-07 1.65362 0.0702378 1.5286 0.195262C1.40357 0.320286 1.33333 0.489856 1.33333 0.666667C1.33333 0.843478 1.40357 1.01305 1.5286 1.13807C1.65362 1.2631 1.82319 1.33333 2 1.33333L5.72667 1.33333L0.193334 6.86C0.130849 6.92198 0.0812515 6.99571 0.0474057 7.07695C0.0135599 7.15819 -0.00386508 7.24533 -0.00386508 7.33333C-0.00386508 7.42134 0.0135599 7.50848 0.0474057 7.58972C0.0812515 7.67096 0.130849 7.74469 0.193334 7.80667V7.80667Z",
    fill: "#22C55E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightUpArrow);
export default __webpack_public_path__ + "static/media/Right-Up Arrow.f35461d875159d1b60984f053e456e20.svg";
export { ForwardRef as ReactComponent };